<template>
  <div class="feedback-history-wrap">

    <ul class="feedback-ul">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <li
          class="item"
          v-for="item in list"
          :class="{me:item.type == 0}"
        >
          <div class="title"><span class="name">{{item.nickname}}</span><span class="time">{{item.create_time}}</span></div>
          <div class="text">{{item.content}}</div>
        </li>
        <!-- <li class="item">
          <div class="title"><span class="name">呼呼客服</span><span class="time">2019-03-20 17:00 </span></div>
          <div class="text">情况已核实，之前的实飞面积为150亩，修改后实飞面积 为110.23亩，请及时验收。请及时验收。请及时验收。 </div>
        </li>
        <li class="item me">
          <div class="title"><span class="name">我</span><span class="time">2019-03-20 17:00 </span></div>
          <div class="text">飞行面积比实际面积大，我无法验收 </div>
        </li> -->
      </van-list>
    </ul>
  </div>
</template>
<script>
import axios from "../../http";
import { mapState } from "vuex";
export default {
  name: "feedback_history",
  components: {},
  props: {},
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      last_id: ""
    };
  },
  computed: {
    ...mapState(["token"])
  },
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {
    onLoad() {
      axios
        .fetchPost("/api/order/feedback_list", {
          token: this.token,
          order_sn: this.$route.query.order_sn,
          page_size: 10,
          last_id: this.last_id
        })
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            let arr = data.data.list;
            this.last_id = data.data.last_id;
            arr.forEach((el, index) => {
              this.list.push(el);
            });
            if (data.data.have_next == 0) {
              this.finished = true;
            } else {
              this.finished = false;
              this.loading = false;
            }
          } else {
            this.finished = true;
          }
        })
        .catch(error => {
          console.log("error :", error);
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
.feedback-history-wrap
  .feedback-ul
    .item
      padding 10px 14px 10px
      text-align left
      .title
        font-size 14px
        font-family Microsoft YaHei
        font-weight 400
        color rgba(85, 204, 153, 1)
        line-height 25px
        color #989898
        margin-bottom 5px
        .name
          margin-right 20px
      &.me
        background #ffffff
        .title
          color #55CC99
      .text
        font-size 14px
        color #282828
        line-height 23px
</style>